module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"tr":{"wasteDescription":"Atık Tanımı","wasteType":"Atığın Tipi/Cinsi","storage":"Depolama Şekli/Yeri","municipality":"İlgili Belediye","recovery":"Geri Dönüşüm","wasteDescriptionEmptyError":"Atık tanımı boş bırakılamaz."},"en":{"wasteDescription":"Waste Description","wasteType":"Waste Type","storage":"Storage","municipality":"Municipality","recovery":"Recovery","wasteDescriptionEmptyError":"Atık tanımı can\u0027t be emtpy."}}')
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@kazupon/vue-i18n-loader/lib!./node_modules/vue-loader/lib/selector.js?type=customBlocks&index=1!./src/components/CustomFormTable.vue
// module id = RpXe
// module chunks = 1